import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../../services/order/order.service';
import { HttpClient } from '@angular/common/http';
import { FilePdfOutline } from '@ant-design/icons-angular/icons';
import { IconService } from '@ant-design/icons-angular';
import { VerificationService } from '../../../services/verification/verification.service';
import { TranslationsService } from '../../../services/translations/translations.service';

@Component({
  selector: 'app-pdf-access',
  templateUrl: './pdf-access.component.html',
  styleUrls: ['./pdf-access.component.scss'],
})
export class PdfAccessComponent implements OnInit {
  constructor(
    private readonly iconService: IconService,
    private readonly httpClient: HttpClient,
    private readonly orderService: OrderService,
    private readonly translationsService: TranslationsService,
    private readonly verificationService: VerificationService
  ) {}

  ngOnInit(): void {
    this.iconService.addIcon(FilePdfOutline);
  }

  showDocument(): void {
    const exported = this.orderService.export();
    this.verificationService.fill(exported, [
      'signature',
      'card_recto',
      'card_verso',
    ]);
    this.httpClient
      .post<string>(`${this.translationsService.getTranslations().api_url}/api/v1/order/generateTemporaryDocuments`, exported, {
        responseType: 'text' as 'json',
      })
      .subscribe((response) =>
        window.open(`${this.translationsService.getTranslations().api_url}/api/v1/order/readTemporaryDocument/${response}`, '_blank')
      );
  }
}
